"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseReferencePath = parseReferencePath;
exports.readReferencePath = readReferencePath;
var _VarsValueTypeHandler = require("../type/VarsValueTypeHandler");
function parseReferencePath(ref) {
  let parts = ref.split(".");
  let path = {
    name: parts[0]
  };
  if (parts.length > 1) {
    path.path = parts.slice(1);
  }
  return path;
}
function readReferencePath(value, path) {
  let val = value;
  if ((0, _VarsValueTypeHandler.isVarsMetaValue)(val)) {
    val = val.value;
  }
  if ((path === null || path === void 0 ? void 0 : path.length) > 0) {
    let copy = [...path];
    while (copy.length > 0 && val) {
      val = val[copy.shift()];
    }
    return val;
  }
  return val;
}
//# sourceMappingURL=path.js.map